import {appRouter} from '@netx/core-next/instance/router';
import type {ReactAction} from '@netx/core/bootstrap';
import {faArrowRight} from '@netx/core-icons';
import {assetNotPending} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';

export const assetActionRouteIcon = faArrowRight;

/**
 * Route to asset
 * @param params
 * @returns Action
 */
export const assetActionRoute = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-route',
	cb: () => appRouter.navigate(`asset/${asset.assetId}`, true),
	enableTest: () => assetNotPending(asset),
	icon: assetActionRouteIcon,
	get label() {
		return AssetActionLabel.ROUTE;
	},
	...params,
});

export default assetActionRoute;
